export default function (context, {cb}) {
    context.commit('clean');
    context.commit('loading', true);
    axios({
        method: 'GET',
        url: '/tourclient/account/permissions?_=' + new Date().getTime(),
    }).then(({data}) => {
        context.commit('set', data);
        context.commit('loading', false);
        if(cb)cb(context.state);
    }).catch(data => {
        context.commit('loading', false);
        context.dispatch('error', data, {root: true});
    });
}